// @flow
import {Typography, makeStyles} from '@material-ui/core';
import React from 'react';
import CustomButton from '../../../../elements/CustomButton/CustomButton';
import {colors} from '../../../../assets/styles/colors';

import productImg from '../../../../assets/img/onboarding/product-step.png';
import {useIsMobile} from '../../../../utils/dom';
import {useStoreBusinessModel} from '../../../store/utils';

type Props = {};

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(1.5),
    backgroundColor: 'white',
    borderRadius: 8,
  },
  content: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column-reverse',
      gap: '12px',
    },
  },
  title: {
    color: colors.grey900,
    fontWeight: 600,
    fontSize: 12,
  },
  subtitle: {
    fontSize: 12,
  },
  button: {
    marginTop: theme.spacing(2),
    borderRadius: 8,
  },
  imgWrap: {
    maxWidth: 100,
  },
  img: {
    maxWidth: '100%',
  },
}));
const ProductStep = (props: Props) => {
  const classes = useStyles();
  const mobile = useIsMobile();

  const businessModel = useStoreBusinessModel();

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <div>
          <Typography className={classes.title} gutterBottom>
            Agrega tu primer producto
          </Typography>

          <Typography className={classes.subtitle} gutterBottom>
            Agrega fotos, una descripción,el precio del producto y más
          </Typography>

          <CustomButton
            fullWidth={mobile}
            variant="contained"
            className={classes.button}
            to="/products/new?fromOnboarding=true"
          >
            Agregar {businessModel === 'PRODUCT' ? 'producto' : 'servicio'}
          </CustomButton>
        </div>

        <div className={classes.imgWrap}>
          <img src={productImg} className={classes.img} alt="" />
        </div>
      </div>
    </div>
  );
};

export default ProductStep;
